import React from "react";
import {
  AiFillFacebook,
  AiFillLinkedin,
  AiFillYoutube,
  AiOutlineArrowUp,
} from "react-icons/ai";

const Footer = () => {
  return (
    <footer>
      <div>
        <img
          src={
            "https://scontent.fbho1-3.fna.fbcdn.net/v/t1.6435-9/66463375_343042239947362_5315756223394480128_n.jpg?_nc_cat=103&ccb=1-7&_nc_sid=174925&_nc_ohc=D9s0qpQy3aEAX8Umcky&_nc_ht=scontent.fbho1-3.fna&oh=00_AfAGW6IJDSjlK-VMCXSSpoE8BaJZPIibo9JPT71H90UZ1Q&oe=63A915C5"
          }
          alt="Founder"
        />

        <h2>Manish Kumar</h2>
        <p>Motivation is temporary, but discipline last forever.</p>
      </div>

      <aside>
        <h2>Social Media</h2>

        <article>
          <a href="https://youtube.com/DevManishKumar" target={"blank"}>
            <AiFillYoutube />
          </a>
          <a
            href="https://www.linkedin.com/in/devmanishkumar/"
            target={"blank"}
          >
            <AiFillLinkedin />
          </a>
          <a
            href="https://www.facebook.com/ManishKumar.Developer/"
            target={"blank"}
          >
            <AiFillFacebook />
          </a>
        </article>
      </aside>
      <a href="#home">
        <AiOutlineArrowUp />
      </a>
    </footer>
  );
};

export default Footer;
